import { render } from "./MiniSkeletonFront.vue?vue&type=template&id=f31c0114"
import script from "./MiniSkeletonFront.vue?vue&type=script&lang=js"
export * from "./MiniSkeletonFront.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__